@if (clip) {
  <div class="player-progress-bar">
    <!-- Progress -->
    <div
      #progress
      class="progress-bar"
      (click)="selectProgress($event)"
      (mouseenter)="showHoverPosition = true"
      (mouseleave)="showHoverPosition = false"
      (mousemove)="hoverProgress($event)"
      >
      <!-- Overtime In/Out Points -->
      @if (inPointOvertime || outPointOvertime) {
        <div #clipOvertimeProgress class="clip-progress-bar overtime"></div>
      }
      @if (inPointOvertime) {
        <div #inPointOvertimePosition class="in-point"></div>
      }
      @if (outPointOvertime) {
        <div #outPointOvertimePosition class="out-point"></div>
      }
      <!-- In/Out point progress -->
      @if (inPoint || outPoint) {
        <div #clipProgress class="clip-progress-bar"></div>
      }
      <!-- In/Out Points -->
      @if (inPoint) {
        <div #inPointPosition class="in-point"></div>
      }
      @if (outPoint) {
        <div #outPointPosition class="out-point"></div>
      }
      <!-- Hover -->
      @if (showHoverPosition && !hoverCurrentPosition && !dragCurrentPosition) {
        <div #hoverPosition class="hover-position"></div>
      }
      @if ((showHoverPosition && !hoverCurrentPosition) || dragCurrentPosition) {
        <div #hoverTC class="hover-timecode">00:00:00:00</div>
      }
      <!-- Current position -->
      <div
        #currentPosition
        class="progress-position"
        [class.drag]="dragCurrentPosition"
        (mouseenter)="hoverCurrentPosition = true"
        (mouseleave)="hoverCurrentPosition = false"
        (appMoveElementStart)="dragStartPlaybackPosition($event)"
        (appMoveElement)="dragMovePlaybackPosition($event)"
        (appMoveElementEnd)="dragEndPlaybackPosition($event)"
      ></div>
    </div>
    <!-- TC -->
    @if (clip.startTimecode) {
      <div class="start-timecode" (click)="jumpTo(0)">{{ clip.startTimecode }}</div>
    }
    @if (clip.endTimecode) {
      <div class="end-timecode" (click)="jumpTo((clip.durationFrames || 1) - 1)">{{ clip.endTimecode }}</div>
    }
  </div>
}
